export const code = {
    tc: 'Traditional Chinese',
    en: 'English'
};